import { ApiClient } from "client/base";
export class ProjectClient extends ApiClient {
    accountClient;
    constructor(base, accountClient) {
        super(base);
        this.accountClient = accountClient;
    }
    getProject(projectId) {
        return this.base.get(`projects/${projectId}`);
    }
    createProject(create) {
        return this.base.post("projects", create);
    }
    updateProject(projectId, update) {
        return this.base.patch(`projects/${projectId}`, update);
    }
    deleteProject(projectId) {
        return this.base.delete(`projects/${projectId}`);
    }
    createProjectRole(projectId, create) {
        return this.base.post(`projects/${projectId}/roles`, create);
    }
    getProjectRoles(projectId) {
        return this.base.get(`projects/${projectId}/roles`);
    }
    getProjectRole(roleId) {
        return this.base.get(`project_roles/${roleId}`);
    }
    updateProjectRole(roleId, update) {
        return this.base.patch(`project_roles/${roleId}`, update);
    }
    deleteProjectRole(roleId) {
        return this.base.delete(`project_roles/${roleId}`);
    }
    createProjectScenario(projectId, create) {
        return this.base.post(`projects/${projectId}/scenarios`, create);
    }
    getProjectScenarios(projectId) {
        return this.base.get(`projects/${projectId}/scenarios`);
    }
    getProjectScenario(scenarioId) {
        return this.base.get(`project_scenarios/${scenarioId}`);
    }
    updateProjectScenario(scenarioId, update) {
        return this.base.patch(`project_scenarios/${scenarioId}`, update);
    }
    deleteProjectScenario(scenarioId) {
        return this.base.delete(`project_scenarios/${scenarioId}`);
    }
    getProjectScenarioComments(scenarioId) {
        return this.base.get(`project_scenarios/${scenarioId}/comments`);
    }
    addProjectScenarioComment(scenarioId, comment) {
        return this.base.post(`project_scenarios/${scenarioId}/comments`, comment);
    }
    getProjectScenarioRatings(scenarioId) {
        return this.base.get(`project_scenarios/${scenarioId}/ratings`);
    }
    addProjectScenarioRating(scenarioId, rating) {
        return this.base.post(`project_scenarios/${scenarioId}/ratings`, rating);
    }
    createProjectScenarioSegment(scenarioId, create) {
        return this.base.post(`project_scenarios/${scenarioId}/segments`, create);
    }
    createProjectScenarioSegmentAssumption(scenarioId, projectSegmentId, create) {
        return this.base.post(`project_scenarios/${scenarioId}/segments/${projectSegmentId}/assumptions`, create);
    }
    addProjectScenarioSegmentAssumption(scenarioId, projectSegmentId, assumptionId) {
        return this.base.post(`project_scenarios/${scenarioId}/segments/${projectSegmentId}/assumptions/${assumptionId}`);
    }
    removeProjectScenarioSegmentAssumption(scenarioId, projectSegmentId, assumptionId) {
        return this.base.delete(`project_scenarios/${scenarioId}/segments/${projectSegmentId}/assumptions/${assumptionId}`);
    }
    createProjectSegment(projectId, create) {
        return this.base.post(`projects/${projectId}/segments/`, create);
    }
    getProjectSegments(projectId) {
        return this.base.get(`projects/${projectId}/segments/`);
    }
    getProjectSegment(projectSegmentId) {
        return this.base.get(`project_segments/${projectSegmentId}`);
    }
    updateProjectSegment(projectSegmentId, update) {
        return this.base.patch(`project_segments/${projectSegmentId}`, update);
    }
    deleteProjectSegment(projectSegmentId) {
        return this.base.delete(`project_segments/${projectSegmentId}`);
    }
    createProjectTask(create) {
        return this.base.post("project_tasks", create);
    }
    createProjectTaskVersion(taskId, create) {
        return this.base.post(`project_tasks/${taskId}/versions`, create);
    }
    getProjectTasks(query = {}) {
        const searchParams = new URLSearchParams("");
        for (const [key, value] of Object.entries(query)) {
            searchParams.append(key, value.toString());
        }
        let url = "project_tasks";
        if (Object.keys(query).length) {
            url += `?${searchParams.toString()}`;
        }
        return this.base.get(url);
    }
    updateProjectTask(taskId, update) {
        return this.base.patch(`project_tasks/${taskId}`, update);
    }
    deleteProjectTask(taskId) {
        return this.base.delete(`project_tasks/${taskId}`);
    }
    getProjectTaskComments(taskId) {
        return this.base.get(`project_tasks/${taskId}/comments`);
    }
    addProjectTaskComment(taskId, comment) {
        return this.base.post(`project_tasks/${taskId}/comments`, comment);
    }
    getProjectTaskRatings(taskId) {
        return this.base.get(`project_tasks/${taskId}/ratings`);
    }
    addProjectTaskRating(taskId, rating) {
        return this.base.post(`project_tasks/${taskId}/ratings`, rating);
    }
    createProjectSegmentTask(projectSegmentId, create) {
        return this.base.post(`project_segments/${projectSegmentId}/tasks/`, create);
    }
    addProjectSegmentTask(projectSegmentId, taskId) {
        return this.base.post(`project_segments/${projectSegmentId}/tasks/${taskId}`);
    }
    removeProjectSegmentTask(projectSegmentId, taskId) {
        return this.base.delete(`project_segments/${projectSegmentId}/tasks/${taskId}`);
    }
}
